<template>
  <div
    class="cell-renderer-badge flex items-center h-full"
    :style="params.cssVariables"
  >
    <div
      class="badge text-inherit flex-shrink-0 flex justify-center items-center"
    >
      <span class="badge-text">
        {{ params.text }}
      </span>
    </div>
  </div>
</template>

<script>
/**
 * @component CellRendererBadge
 * @description テーブル内のバッジをレンダリング
 * @data
 *   - params: 以下のプロパティを含むオブジェクト:
 *     - cssVariables: バッジのスタイリングに使用するCSS変数を含むオブジェクト
 *       - '--badge-bg-color': バッジの背景色
 *       - '--badge-color': バッジのテキスト色
 *     - text: バッジ内に表示するテキスト
 * @note
 * cellRendererParams を利用して params を渡す
 */
export const cssVariableNames = {
  badgeBgColor: "--badge-bg-color",
  badgeColor: "--badge-color",
};
export default {
  name: "CellRendererBadge",
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";
.cell-renderer-badge {
  --badge-bg-color: $aisea-red; // override background-color
  --badge-color: $aisea-pure-white; // override color
  --badge-font-size: 14px; // override color
  .badge {
    min-width: 70px;
    height: 24px;
    border-radius: 30px;
    line-height: 1;
    background-color: var(--badge-bg-color);
    color: var(--badge-color);
    font-size: var(--badge-font-size);
  }
}
</style>
